(() => {
  const roots = document.querySelectorAll('[data-littleg-tool-execution]');

  const text = (value, fallback = '') =>
    typeof value === 'string' && value.trim()
      ? value.trim().slice(0, 500)
      : fallback;

  const requestId = () =>
    window.crypto?.randomUUID?.() ||
    `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  const sessionSubject = () => {
    try {
      const state = window.LittleGWebSession?.getState?.();
      return state?.status === 'authenticated' && typeof state.profile?.id === 'string'
        ? state.profile.id.trim() : '';
    } catch { return ''; }
  };
  const activeToolsTab = () => {
    try { return new URL(window.location.href).searchParams.get('tab') === 'tools'; }
    catch { return false; }
  };

  roots.forEach((root) => {
    const message = root.querySelector('[data-execution-message]');
    const tool = root.querySelector('[data-execution-tool]');
    const entitlement = root.querySelector('[data-execution-entitlement]');
    const quote = root.querySelector('[data-execution-quote]');
    const status = root.querySelector('[data-execution-status]');
    const checkButton = root.querySelector('[data-execution-check]');
    const runButton = root.querySelector('[data-execution-run]');

    let activeRequestId = '';
    let currentToolId = '';
    let confirmedQuoteId = '';
    let canRun = false;
    let currentSubject = '';

    const setMessage = (value) => {
      message.textContent = value;
    };

    const setReady = (ready) => {
      canRun = ready;
      runButton.disabled = !ready;
    };

    const resetPrivate = () => {
      activeRequestId = '';
      currentToolId = '';
      confirmedQuoteId = '';
      setReady(false);
      tool.textContent = '尚未選擇';
      entitlement.textContent = '待核對';
      quote.textContent = '待確認';
      status.textContent = '尚未開始';
      setMessage('請先在 Dashboard 選擇工具。');
    };
    const sessionAuthorized = () => {
      const panel = root.closest('[data-my-tools-private]');
      return Boolean(sessionSubject() && activeToolsTab() && panel && !panel.hidden);
    };
    const syncPrivateSession = () => {
      const next = sessionSubject();
      if (!next || next !== currentSubject || !activeToolsTab()) {
        currentSubject = next;
        resetPrivate();
      }
    };

    const dispatchRequest = (action, extra = {}) => {
      activeRequestId = requestId();
      root.dispatchEvent(new CustomEvent('littleg:tool-execution-request', {
        bubbles: true,
        detail: {
          action,
          requestId: activeRequestId,
          toolId: currentToolId,
          ...extra
        }
      }));
    };

    const check = () => {
      if (!currentToolId || !sessionAuthorized() ||
          currentSubject !== sessionSubject()) {
        resetPrivate();
        return;
      }
      confirmedQuoteId = '';
      setReady(false);
      entitlement.textContent = '核對中';
      quote.textContent = '核對中';
      setMessage('正在向服務端核對身份、權益及報價…');
      dispatchRequest('check');
    };

    checkButton.addEventListener('click', check);

    runButton.addEventListener('click', () => {
      if (!sessionAuthorized() || currentSubject !== sessionSubject() ||
          !canRun || !currentToolId || !confirmedQuoteId) return;
      setReady(false);
      status.textContent = '提交中';
      setMessage('正在提交執行請求…');
      dispatchRequest('execute', { quoteId: confirmedQuoteId });
    });

    document.addEventListener('littleg:tool-selected', (event) => {
      if (!sessionAuthorized()) return;
      const nextSubject = sessionSubject();
      if (nextSubject !== currentSubject) {
        currentSubject = nextSubject;
        resetPrivate();
      }
      const nextToolId = text(event.detail?.toolId);
      if (!nextToolId) return;
      currentToolId = nextToolId;
      tool.textContent = text(event.detail?.title, '已選擇工具');
      status.textContent = '尚未開始';
      check();
    });

    document.addEventListener('littleg:tool-execution-response', (event) => {
      if (!sessionAuthorized() || currentSubject !== sessionSubject()) {
        resetPrivate();
        return;
      }
      const data = event.detail;
      if (!data || data.requestId !== activeRequestId ||
          data.toolId !== currentToolId) return;

      if (data.error) {
        setReady(false);
        entitlement.textContent = '無法確認';
        quote.textContent = '無法確認';
        status.textContent = '未執行';
        setMessage(text(data.error, '暫時無法完成請求，請稍後重試。'));
        return;
      }

      if (data.action === 'check') {
        const eligible = data.eligible === true;
        confirmedQuoteId = eligible ? text(data.quoteId) : '';
        entitlement.textContent = eligible ? '已核對' : '尚未解鎖';
        quote.textContent = eligible
          ? text(data.quoteLabel, '報價未提供')
          : '不可用';
        setReady(eligible && Boolean(confirmedQuoteId) &&
          Boolean(text(data.quoteLabel)));
        status.textContent = '尚未開始';
        setMessage(
          runButton.disabled
            ? text(data.message, '目前不能執行。請檢查登入、購買權益與報價。')
            : '請核對本次報價，再按「確認報價並執行」。'
        );
        return;
      }

      if (data.action === 'execute') {
        status.textContent = text(data.statusLabel, '已提交');
        setMessage(text(data.message, '執行請求已提交，正在等待結果。'));
        // 結果須由 Core 另外授權讀取；不從執行回應直接展示私人資料。
      }
    });

    document.addEventListener('littleg:web-session-change', syncPrivateSession);
    window.addEventListener('pageshow', syncPrivateSession);
    window.addEventListener('popstate', syncPrivateSession);
    syncPrivateSession();
  });
})();
